import { FilterFieldParams, filterFieldsToListParams } from "@ukam/core/filters/params/filter-field.params";
import { Filter } from "../models/filter";

export interface FilterParams {
  key?: string | null;
  feature?: string | null;
  type?: string | null;
  description?: string | null;
  refCode?: string | null;
  note?: string | null;
  fields?: FilterFieldParams[] | null;
  searchText?: string | null;
  unitId?: string | null;
  partnerId?: string | null;
  branchId?: string | null;
  agentId?: string | null;
  userId?: string | null;
}

export function filterToParams(filter: Filter): FilterParams {
  return {
    key: filter.key,
    feature: filter.feature?.key,
    type: filter.type?.key,
    description: filter.description,
    refCode: filter.refCode,
    note: filter.note,
    fields: filterFieldsToListParams(filter.fields),
    searchText: filter.searchText,
    unitId: filter.unit?.id,
    partnerId: filter.partner?.id,
    branchId: filter.branch?.id,
    agentId: filter.agent?.id,
    userId: filter.user?.id,
  };
}
